import http from './http';

const ENDPOINTS = {
  // Queue management endpoints
  DOCTOR_QUEUE: (doctorId) => `/api/v1/queue/${doctorId}`,
  QUEUE_SUMMARY: (doctorId) => `/api/v1/queue/doctor/${doctorId}/summary`,

  // Individual appointment queue operations
  APPOINTMENT_JOIN_QUEUE: (id) => `/api/v1/appointments/${id}/join-queue`,
  APPOINTMENT_START_SERVICE: (id) => `/api/v1/appointments/${id}/start-service`,
  APPOINTMENT_COMPLETE_SERVICE: (id) => `/api/v1/appointments/${id}/complete-service`,
  APPOINTMENT_MARK_ARRIVED: (id) => `/api/v1/appointments/${id}/arrived`,
};

/**
 * Queue Management API Service
 */
export const queueAPI = {
  /**
   * Get doctor's current queue with all appointments
   */
  getDoctorQueue: async (doctorId, date = null) => {
    const params = date ? { date } : {};
    const response = await http.get(ENDPOINTS.DOCTOR_QUEUE(doctorId), { params });
    return response.data;
  },

  /**
   * Get comprehensive queue summary for a doctor
   */
  getQueueSummary: async (doctorId, date = null) => {
    const params = date ? { date } : {};
    const response = await http.get(ENDPOINTS.QUEUE_SUMMARY(doctorId), { params });
    return response.data;
  },

  /**
   * Add appointment to queue (individual)
   */
  joinQueue: async (appointmentId) => {
    const response = await http.post(ENDPOINTS.APPOINTMENT_JOIN_QUEUE(appointmentId));
    return response.data;
  },

  /**
   * Start service for an appointment
   */
  startService: async (appointmentId) => {
    const response = await http.post(ENDPOINTS.APPOINTMENT_START_SERVICE(appointmentId));
    return response.data;
  },

  /**
   * Complete service for an appointment
   */
  completeService: async (appointmentId) => {
    const response = await http.post(ENDPOINTS.APPOINTMENT_COMPLETE_SERVICE(appointmentId));
    return response.data;
  },

  /**
   * Mark patient as arrived (ready to join queue)
   */
  markArrived: async (appointmentId) => {
    const response = await http.post(ENDPOINTS.APPOINTMENT_MARK_ARRIVED(appointmentId));
    return response.data;
  },

  /**
   * Get doctor's current queue (legacy method for backward compatibility)
   * @deprecated Use getQueueSummary instead
   */
  getDoctorQueue: async (doctorId) => {
    console.warn('getDoctorQueue is deprecated. Use getQueueSummary instead.');
    return await queueAPI.getQueueSummary(doctorId);
  },

  /**
   * Get next appointment in queue (legacy method)
   * @deprecated Use getQueueSummary and check currentPatient instead
   */
  getNextInQueue: async (doctorId) => {
    console.warn('getNextInQueue is deprecated. Use getQueueSummary instead.');
    const summary = await queueAPI.getQueueSummary(doctorId);
    return {
      success: true,
      data: summary.data?.queueSummary?.currentPatient || null
    };
  }
};

export default queueAPI;
